module.exports = __webpack_public_path__ + "static/img/23-Kao-Data-Centre-Harlow.84c42b06.png";